<div
    class="sb-badge-container"
    [ngClass]="kind() !== BadgeKind.Dot ? [color(), kind()] : [kind()]">
    @if (kind() === BadgeKind.Dot) {
        <span class="sb-badge-dot-container" [ngClass]="[color()]"></span>
    } @else {
        <span class="sb-badge-text">{{ displayText() }}</span>
    }
</div>
